import { createApiQuery } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseGetConsentStatusRequest, UseGetConsentStatusData, UseGetCustomerConsentPageRequest, UseGetCustomerConsentPageData, UseGetSignedConsentDetailRequest, UseGetSignedConsentDetailData, UseGetTemplateDetailRequest, UseGetTemplateDetailData, UseGetTemplatePageRequest, UseGetTemplatePageData, UseGetVersionRequest, UseGetVersionData, UseGetVersionHistoryListRequest, UseGetVersionHistoryListData, UsePreviewConsentRequest, UsePreviewConsentData } from "@api/@types/consent";

export const useGetConsentStatus = createApiQuery<UseGetConsentStatusData, UseGetConsentStatusRequest>({
  queryKey: (req) => ["getConsentStatus", req?.groupId, req?.userId],
  queryFn: (req) => apiClientManager.apis.consent.getConsentStatus(req as UseGetConsentStatusRequest),
  extractData: (res) => res.data.data as UseGetConsentStatusData,
  isEnabled: (req) => Boolean(req?.groupId && req?.userId),
});

export const useGetCustomerConsentPage = createApiQuery<UseGetCustomerConsentPageData, UseGetCustomerConsentPageRequest>({
  queryKey: (req) => ["getCustomerConsentPage", req?.groupId, req?.userId, req?.pageable],
  queryFn: (req) => apiClientManager.apis.consent.getCustomerConsentPage(req as UseGetCustomerConsentPageRequest),
  extractData: (res) => res.data.data as UseGetCustomerConsentPageData,
  isEnabled: (req) => Boolean(req?.groupId && req?.userId && req?.pageable),
});

export const useGetSignedConsentDetail = createApiQuery<UseGetSignedConsentDetailData, UseGetSignedConsentDetailRequest>({
  queryKey: (req) => ["getSignedConsentDetail", req?.groupId, req?.userId, req?.signedConsentId],
  queryFn: (req) => apiClientManager.apis.consent.getSignedConsentDetail(req as UseGetSignedConsentDetailRequest),
  extractData: (res) => res.data.data as UseGetSignedConsentDetailData,
  isEnabled: (req) => Boolean(req?.groupId && req?.userId && req?.signedConsentId),
});

export const useGetTemplateDetail = createApiQuery<UseGetTemplateDetailData, UseGetTemplateDetailRequest>({
  queryKey: (req) => ["getTemplateDetail", req?.groupId, req?.templateId],
  queryFn: (req) => apiClientManager.apis.consent.getTemplateDetail(req as UseGetTemplateDetailRequest),
  extractData: (res) => res.data.data as UseGetTemplateDetailData,
  isEnabled: (req) => Boolean(req?.groupId && req?.templateId),
});

export const useGetTemplatePage = createApiQuery<UseGetTemplatePageData, UseGetTemplatePageRequest>({
  queryKey: (req) => ["getTemplatePage", req?.groupId, req?.pageable, req?.activeOnly],
  queryFn: (req) => apiClientManager.apis.consent.getTemplatePage(req as UseGetTemplatePageRequest),
  extractData: (res) => res.data.data as UseGetTemplatePageData,
  isEnabled: (req) => Boolean(req?.groupId && req?.pageable),
});

export const useGetVersion = createApiQuery<UseGetVersionData, UseGetVersionRequest>({
  queryKey: (req) => ["getVersion", req?.groupId, req?.templateId, req?.versionNumber],
  queryFn: (req) => apiClientManager.apis.consent.getVersion(req as UseGetVersionRequest),
  extractData: (res) => res.data.data as UseGetVersionData,
  isEnabled: (req) => Boolean(req?.groupId && req?.templateId && req?.versionNumber),
});

export const useGetVersionHistoryList = createApiQuery<UseGetVersionHistoryListData, UseGetVersionHistoryListRequest>({
  queryKey: (req) => ["getVersionHistoryList", req?.groupId, req?.templateId],
  queryFn: (req) => apiClientManager.apis.consent.getVersionHistoryList(req as UseGetVersionHistoryListRequest),
  extractData: (res) => res.data.data as UseGetVersionHistoryListData,
  isEnabled: (req) => Boolean(req?.groupId && req?.templateId),
});

export const usePreviewConsent = createApiQuery<UsePreviewConsentData, UsePreviewConsentRequest>({
  queryKey: (req) => ["previewConsent", req?.groupId, req?.userId, req?.templateId, req?.petId],
  queryFn: (req) => apiClientManager.apis.consent.previewConsent(req as UsePreviewConsentRequest),
  extractData: (res) => res.data.data as UsePreviewConsentData,
  isEnabled: (req) => Boolean(req?.groupId && req?.userId && req?.templateId),
});

export type { UseGetConsentStatusRequest, UseGetConsentStatusData, UseGetCustomerConsentPageRequest, UseGetCustomerConsentPageData, UseGetSignedConsentDetailRequest, UseGetSignedConsentDetailData, UseGetTemplateDetailRequest, UseGetTemplateDetailData, UseGetTemplatePageRequest, UseGetTemplatePageData, UseGetVersionRequest, UseGetVersionData, UseGetVersionHistoryListRequest, UseGetVersionHistoryListData, UsePreviewConsentRequest, UsePreviewConsentData } from "@api/@types/consent";
